import React from 'react';
import {ICommentModel} from '@src/@interfaces/models/Comment/ICommentModel';
import {prepareMessage} from '@src/components/CommentsList/CommentInline';
import PlainCommentAttachments from '@src/components/CommentsList/PlainComment/PlainCommentAttachments';
import TextContainerWithOptionalClassName, {
    TTextContainerWithOptionalClassNameProps
} from '@src/components/CommentsList/PlainComment/TextContainerWithOptionalClassName';

export default function PlainComment(props: {
    comment: ICommentModel,
    attachmentsContainerCLassName?: TTextContainerWithOptionalClassNameProps['className'],
    hideAttachments?: boolean,
} & TTextContainerWithOptionalClassNameProps) {
    const {comment, tag, className, attachmentsContainerCLassName, hideAttachments = false} = props;

    return <TextContainerWithOptionalClassName tag={tag} className={className}>
        {hideAttachments ? null : (
                <PlainCommentAttachments
                        comment={comment}
                        className={attachmentsContainerCLassName}
                />
        )}
        {prepareMessage(comment.message)}
    </TextContainerWithOptionalClassName>;
}
